/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

function FooterComponent() {
  return (
    <>
      <footer className="rx_footer">
        <div className="container">
          <div className="row p-0">
            <div className="col-md-6 col-sm-6 col-12">
              <div className="footer_left">
                <p>{new Date().getFullYear()} © Reg-X</p>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-12">
              <div className="footer_right">
                <ul style={{ marginBottom: 0 }}>
                  <li>
                    <a
                      href="https://reg-x.co.uk/#homeabout-section"
                      target="_blank"
                      rel="noreferrer"
                    >
                      About Us
                    </a>
                  </li>
                  <li>
                    <a href="mailto:support@reg-x.co.uk?subject=Help">Help</a>
                  </li>
                  <li>
                    <a
                      href="https://reg-x.co.uk/contact-us/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterComponent;
